import React from "react"

import { libraryPostTypes } from "../../../features/userGeneratedContent/lib/postTypes"

import AllPosts from "../../../features/businessLibrary/containers/AllPosts"
import BrowseLibraryLayout from "../../../layouts/BrowseLibraryLayout"
import SideBar from "../../../features/businessLibrary/containers/SideBar"
import TopBar from "../../../features/businessLibrary/containers/TopBar"

const AllLectures = AllPosts(libraryPostTypes.lectures)

const Lectures = () => (
  <BrowseLibraryLayout
    sideColumn={SideBar(libraryPostTypes.lectures)}
    topRow={TopBar(libraryPostTypes.lectures)}
  >
    <AllLectures />
  </BrowseLibraryLayout>
)

export default Lectures
